import $ from 'jquery';
import {Subject} from 'rxjs';
import LocalStorageService from './LocalStorageService';

export default class {
    constructor(storageKey) {

        this.apiUrl = window._env.config.apiUrl;
        this.userId = window._env.current_user_id;

        this.localStorageService = new LocalStorageService();
        this.optionsSubject = new Subject([]);

        this.key = storageKey;
        this._selectedOptions = JSON.parse(this.localStorageService.getKey(this.key)) || [];

        this.options = $('input[type=checkbox]');
        this.$submitButton = $('#quiz-submit');

        this.init();
    }

    init() {
        const {options, localStorageService, shouldDisableButton, $submitButton} = this;

        // reconcile page load with localStorage
        options.each((_, el) => {
            if (this._selectedOptions.some(option => option === el.value)) {
                $(el).attr('checked', true);
            }
        })

        // attach click handlers
        options.on('click', (e) => this.handleOptionSelect(e));

        // subscribe to changes
        this.optionsSubject.subscribe(
            selectedOptions => {
                localStorageService.setKey(this.key, JSON.stringify(selectedOptions))
                $submitButton.attr('disabled', shouldDisableButton.bind(this))
            }
        )

        // check page validation
        $submitButton.attr('disabled', shouldDisableButton.bind(this))
    }

    handleOptionSelect({currentTarget}) {
        const {key, options} = this;

        // account for body shape page
        if (key === 'bravabod_bodytype') {

            options.each((_, el) => {
                if (el.value !== currentTarget.value) {
                    $(el).attr('checked', false);
                }
            });

            this._selectedOptions = currentTarget.checked ? [currentTarget.value] : [];

        } else {
            if (currentTarget.id === 'i_like_it_all') {
                if (currentTarget.checked) {
                    $('input.c-card:not(#i_like_it_all):not(:checked)').attr('checked', true);
                    this._selectedOptions = $.map(options, o => $(o).val());
                } else {
                    $('input.c-card:not(#i_like_it_all):checked').attr('checked', false);
                    this._selectedOptions = [];
                }
                return this.optionsSubject.next([...this._selectedOptions]);
            }

            if (currentTarget.checked) {
                this._selectedOptions.push(currentTarget.value);

                // account for i_like_it_all
                const indexOfAll = this._selectedOptions.indexOf('i_like_it_all');
                const selectedCount = this._selectedOptions.length;
                if (indexOfAll === -1 && selectedCount === (options.length - 1)) {
                    const selectedOptions = [...this._selectedOptions]
                    selectedOptions.push('i_like_it_all');
                    this._selectedOptions = [...selectedOptions];
                    $('#i_like_it_all').attr('checked', true);
                }

            } else {
                const index = this._selectedOptions.indexOf(currentTarget.value);

                if (index !== -1) {
                    const selectedOptions = [...this._selectedOptions]
                    selectedOptions.splice(index, 1);
                    this._selectedOptions = [...selectedOptions];
                }

                // account for i_like_it_all
                const indexOfAll = this._selectedOptions.indexOf('i_like_it_all');

                if (indexOfAll !== -1) {
                    const selectedOptions = [...this._selectedOptions]
                    selectedOptions.splice(indexOfAll, 1);
                    this._selectedOptions = [...selectedOptions];
                    $('#i_like_it_all').attr('checked', false);
                }
            }
        }

        return this.optionsSubject.next([...this._selectedOptions]);
    }

    submitResults() {

        console.log('Submitting results...');
        
        const {apiUrl, userId, localStorageService} = this;
        console.log(`API Url: ${apiUrl}quiz/results/`)

        const bodyTypes = JSON.parse(localStorageService.getKey('bravabod_bodytype'));
        const dislikes = JSON.parse(localStorageService.getKey('bravabod_dislikes'));
        const foods = JSON.parse(localStorageService.getKey('bravabod_foods'));
        $.ajax({
            type: 'POST',
            url: `${apiUrl}quiz/results/`,
            data: {
                user_id: userId,
                body_type: bodyTypes ? bodyTypes.join() : '',
                dislikes: dislikes ? dislikes.join()  : '',
                favorite_foods: foods ? foods.join() : '',
            },
        })
            .then(result => {
                JSON.parse(result)
                console.log('Quiz results: ')
                console.log(result)
            })
    }


    shouldDisableButton() {
        const {key, _selectedOptions} = this;

        switch (key) {
            case 'bravabod_foods':
                return _selectedOptions.length < 3;
            case 'bravabod_bodytype':
                return _selectedOptions.length !== 1;
            default:
                return false;
        }
    }
}



// WEBPACK FOOTER //
// ./scripts/modules/QuizController.js